// src/Login.jsx
import React, { useState } from "react";
import { Link } from 'react-router-dom';


export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    const res = await fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email, password }),
    });

    if (res.ok) {
      // ✅ Give the session cookie time to persist
      await new Promise((resolve) => setTimeout(resolve, 200));

      // ✅ Confirm session is usable before redirecting
      const sessionRes = await fetch("/api/me", {
        credentials: "include",
      });

      if (sessionRes.ok) {
        window.location.href = "/";
      } else {
        setError("Login succeeded but session failed. Try refreshing.");
      }

    } else {
      setError("Invalid email or password");
    }
  };



  return (
    <div className="flex flex-col items-center justify-center h-screen px-4">
      <h1 className="text-2xl font-bold mb-6">Inventory Login</h1>
      <form onSubmit={handleLogin} className="w-full max-w-sm space-y-4">
        <input
          className="w-full p-2 border rounded"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          className="w-full p-2 border rounded"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          Sign In
        </button>
        {error && <p className="text-red-600 text-sm">{error}</p>}
      </form>
      <div className="text-center mt-4">
        <Link to="/admin-login" className="text-blue-500 underline hover:text-blue-700">
          Admin User Panel
        </Link>
      </div>
    </div>
  );
}
